// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isTokenUsage = objectOf({
  prompt_tokens: maybe(number, true),
  completion_tokens: maybe(number, true),
  total_tokens: maybe(number, true),
  cached_tokens: maybe(number, true),
  reasoning_tokens: maybe(number, true),
});

const isToolExecutionLog = objectOf({
  name: string,
  arguments: maybe(string, true),
  duration: number,
});

const isCallingObjectInformation = objectOf({
  object_type: maybe(string, true),
  name: maybe(string, true),
  user_id: maybe(string, true),
  item_id: maybe(string, true),
});

const isGenerativeAiAgentIdLogsResultItem = objectOf({
  invocation_id: string,
  start_time: number,
  duration: maybe(number, true),
  is_error: boolean,
  prompt: string,
  response_message: string,
  token_usage: maybe(isTokenUsage, true),
  tool_execution_logs: maybe(arrayOf(isToolExecutionLog), true),
  calling_object_information: maybe(isCallingObjectInformation, true),
  agent_model_name: maybe(string, true),
  agent_model_provider_name: maybe(string, true),
  braze_model_when_using_auto: maybe(string, true),
  llm_owned_by_customer: maybe(boolean, true),
});

export const isGenerativeAiAgentIdLogsResult = objectOf({
  hits: number,
  results: arrayOf(isGenerativeAiAgentIdLogsResultItem),
});
